import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'logoInput',
    'hiddenLogoInput',
    'iconSelect',
    'colorSelect'
  ]

  static values = {
    logoPresent: Boolean
  }

  declare readonly hasLogoInputTarget: boolean
  declare readonly logoInputTarget: HTMLInputElement
  declare readonly hasHiddenLogoInputTarget: boolean
  declare readonly hiddenLogoInputTarget: HTMLInputElement
  declare readonly hasIconSelectTarget: boolean
  declare readonly iconSelectTarget: HTMLSelectElement
  declare readonly hasColorSelectTarget: boolean
  declare readonly colorSelectTarget: HTMLSelectElement
  declare logoPresentValue: boolean

  connect (): void {
    this.updateBrandingFields()
  }

  logoSelected (): void {
    if (!this.hasIconSelectTarget || !this.hasColorSelectTarget) return

    this.updateLogoPresence(this.logoHasValue())
  }

  logoRemoved (): void {
    if (!this.hasIconSelectTarget || !this.hasColorSelectTarget) return

    this.clearLogoInputs()
    this.updateLogoPresence(false)
  }

  private updateBrandingFields (): void {
    if (!this.hasIconSelectTarget || !this.hasColorSelectTarget) return

    const hasLogo = this.logoPresentValue || this.logoHasValue()
    this.updateLogoPresence(hasLogo)
  }

  private updateLogoPresence (present: boolean): void {
    this.logoPresentValue = present
    this.toggleIconAndColorFields()
  }

  private toggleIconAndColorFields (): void {
    const disabled = this.logoPresentValue

    if (this.hasIconSelectTarget) this.toggleSelect(this.iconSelectTarget, disabled)
    if (this.hasColorSelectTarget) this.toggleSelect(this.colorSelectTarget, disabled)
  }

  private toggleSelect (select: HTMLSelectElement, disabled: boolean): void {
    select.disabled = disabled

    const plugin = (select as unknown as { tomselect?: { disable: () => void, enable: () => void } }).tomselect
    if (plugin != null) {
      disabled ? plugin.disable() : plugin.enable()
    }
  }

  private logoHasValue (): boolean {
    const hasFile = this.hasLogoInputTarget && (this.logoInputTarget.files?.length ?? 0) > 0
    const hasHiddenValue = this.hasHiddenLogoInputTarget && this.hiddenLogoInputTarget.value.trim().length > 0

    return hasFile || hasHiddenValue
  }

  private clearLogoInputs (): void {
    if (this.hasLogoInputTarget) {
      this.logoInputTarget.value = ''
    }

    if (this.hasHiddenLogoInputTarget) {
      this.hiddenLogoInputTarget.value = ''
    }
  }
}
